import { apolloClient } from '~/apollo-client';
import { ZuoraLinkToken, ZuoraLinkTokenMethodType } from '~/typings/graphql';
import { CREATE_ZUORA_LINK_TOKEN } from './create-zuora-link-token.queries';

export interface CreateZuoraLinkTokenParams {
  methodType: ZuoraLinkTokenMethodType;
}

interface CreateZuoraLinkTokenMutationResponse {
  createZuoraLinkToken: ZuoraLinkToken;
}

interface CreateZuoraLinkTokenMutationVariables {
  input: CreateZuoraLinkTokenParams;
}

export const createZuoraLinkToken = async (
  params: CreateZuoraLinkTokenParams,
): Promise<ZuoraLinkToken> => {
  const { data } = await apolloClient.mutate<
    CreateZuoraLinkTokenMutationResponse,
    CreateZuoraLinkTokenMutationVariables
  >({
    mutation: CREATE_ZUORA_LINK_TOKEN,
    variables: {
      input: {
        methodType: params.methodType,
      },
    },
    fetchPolicy: 'no-cache',
  });

  return data?.createZuoraLinkToken as ZuoraLinkToken;
};
